<div class="updateDataContainer" id="updateDataContainer">
  <div class="updateDataBackdrop" id="updateDataBackdrop"></div>
  <div
    *ngIf="step === 1"
    class="updateDataModalWelcome"
    id="updateDataModalWelcome"
  >
    <div class="updateDataModalWelcomeText" id="updateDataModalWelcomeText">
      <h1>¡Hola!</h1>
      <h2>Necesitamos actualizar algunos datos.</h2>
    </div>
    <button
      (click)="toStep2()"
      class="updateDataButton"
      id="updateDataButtonWelcome"
    >
      Vamos
    </button>
  </div>

  <div *ngIf="step === 2" class="updateDataModalForm" id="updateDataModalForm">
    <div class="updateDataModalFormContainer" id="updateDataModalFormContainer">
      <h1>Actualizar Información</h1>
      <div class="InputsContainer" id="InputsContainer">
        <label for="birthDate">Fecha de nacimiento</label>
        <input
          type="date"
          id="birthDate"
          class="InputsContainerInput"
          [(ngModel)]="selectedDate"
          placeholder="DD/MM/AAAA"
          [max]="maxDate"
          required
          onblur="this.classList.add('touched')"
        />
        <p class="errorMsg">Este campo no puede estar vacio*</p>
      </div>
      <app-google-maps-input
        (selectedDirection)="selectedDirection = $event"
        [direction]="selectedDirection"
      />
    </div>
    <button
      [disabled]="!selectedDate || !selectedDirection"
      class="updateDataButton"
      id="updateDataButtonForm"
      (click)="handleSetUpdateAuthorization()"
    >
      Enviar
    </button>
  </div>

  <div
    *ngIf="step === 3"
    class="updateDataModalFinish"
    id="updateDataModalFinish"
  >
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="status"
    >
      <g clip-path="url(#clip0_17281_506)">
        <path
          d="M32.4932 9.94653C31.9725 9.42581 31.0449 9.39248 30.5298 9.94653C30.2923 10.202 30.0549 10.4575 29.8174 10.7117C29.1898 11.3851 28.5635 12.06 27.9359 12.7335C27.0472 13.6888 26.1585 14.6428 25.2698 15.5981C24.2477 16.6965 23.2257 17.7935 22.2051 18.8919C21.1789 19.9944 20.1514 21.097 19.1252 22.2009C18.2226 23.1716 17.3186 24.1408 16.416 25.1114C15.8287 25.7419 15.2427 26.3723 14.6553 27.0027C14.4526 26.7722 14.2498 26.5403 14.0485 26.3098C13.0737 25.1975 12.1003 24.0853 11.1255 22.973C10.5756 22.344 10.0243 21.7163 9.47443 21.0873C9.47305 21.0859 9.47305 21.0859 9.47166 21.0845C9.23698 20.8179 8.83568 20.6776 8.48992 20.6776C8.12333 20.6776 7.76785 20.8248 7.50818 21.0845C7.24851 21.3442 7.10132 21.6996 7.10132 22.0662C7.10132 22.4536 7.25962 22.7633 7.50818 23.048C8.02751 23.6409 8.54824 24.2352 9.06758 24.8282C10.0424 25.9404 11.0158 27.0527 11.9906 28.165C12.5405 28.794 13.0917 29.4216 13.6416 30.0507C13.643 30.0521 13.643 30.0521 13.6444 30.0535C14.1304 30.6089 15.1177 30.5811 15.6079 30.0535C15.8453 29.798 16.0828 29.5424 16.3202 29.2883C16.9479 28.6149 17.5741 27.94 18.2018 27.2665C19.0905 26.3112 19.9792 25.3572 20.8679 24.4019C21.8899 23.3035 22.9119 22.2065 23.9325 21.1081C24.9587 20.0055 25.9863 18.903 27.0124 17.7991C27.915 16.8284 28.819 15.8592 29.7216 14.8886C30.3729 14.1887 31.0241 13.4889 31.6754 12.789C31.9461 12.4974 32.2183 12.2058 32.4891 11.9142C32.4905 11.9128 32.4919 11.9114 32.4932 11.91C32.7474 11.6378 32.9001 11.306 32.9001 10.9283C32.9001 10.5617 32.7529 10.2062 32.4932 9.94653Z"
          fill="#7DFFB2"
        />
        <path
          d="M20 0C8.95369 0 0 8.95369 0 20C0 31.0463 8.95369 40 20 40C31.0463 40 40 31.0463 40 20C40 8.95369 31.0463 0 20 0ZM20 37.5811C10.2895 37.5811 2.41894 29.7091 2.41894 20C2.41894 10.2909 10.2909 2.41894 20 2.41894C29.7091 2.41894 37.5811 10.2909 37.5811 20C37.5811 29.7091 29.7105 37.5811 20 37.5811Z"
          fill="#7DFFB2"
        />
      </g>
      <defs>
        <clipPath id="clip0_17281_506">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="status === false"
    >
      <g clip-path="url(#clip0_17281_589)">
        <path
          d="M20 0.5C8.95408 0.5 0 9.45408 0 20.5C0 31.5459 8.95408 40.5 20 40.5C31.0459 40.5 40 31.5459 40 20.5C40 9.45408 31.0459 0.5 20 0.5ZM20 38.1435C10.2556 38.1435 2.3565 30.2444 2.3565 20.5C2.3565 10.7556 10.2556 2.8565 20 2.8565C29.7444 2.8565 37.6435 10.7556 37.6435 20.5C37.6435 30.2444 29.7444 38.1435 20 38.1435Z"
          fill="#FF7D7D"
        />
        <path
          d="M29.3269 28.1175C27.6442 26.4347 25.9614 24.7519 24.2786 23.0692C23.4224 22.213 22.5656 21.3562 21.7094 20.5L23.5396 18.6698C25.3003 16.909 27.0611 15.1483 28.8218 13.3876C29.6774 12.532 30.5584 11.6945 31.3922 10.8172C31.4043 10.8045 31.4164 10.793 31.4291 10.7803C31.8768 10.3326 31.91 9.51267 31.4291 9.07158C30.9469 8.62868 30.1976 8.59363 29.7203 9.07158C29.0194 9.77249 28.3191 10.4728 27.6182 11.1737L22.5698 16.222L20.0007 18.7912L18.1704 16.961L12.8883 11.6788C12.0327 10.8232 11.1952 9.94227 10.3179 9.10844C10.3052 9.09635 10.2937 9.08427 10.281 9.07158C9.83328 8.62385 9.01334 8.59061 8.57225 9.07158C8.12935 9.55375 8.09431 10.303 8.57225 10.7803C9.27316 11.4812 9.97346 12.1815 10.6744 12.8825C12.3571 14.5652 14.0399 16.248 15.7227 17.9308C16.5789 18.787 17.4357 19.6438 18.2919 20.5L16.4617 22.3302C14.701 24.0909 12.9402 25.8516 11.1795 27.6124C10.3239 28.468 9.44295 29.3054 8.60911 30.1828C8.59702 30.1954 8.58494 30.2069 8.57225 30.2196C8.12452 30.6673 8.09128 31.4873 8.57225 31.9284C9.05443 32.3713 9.80367 32.4063 10.281 31.9284C10.9819 31.2275 11.6822 30.5272 12.3831 29.8263C14.0659 28.1435 15.7487 26.4607 17.4315 24.7779L20.0007 22.2087L21.8309 24.039C23.5916 25.7997 25.3523 27.5604 27.113 29.3211C27.9686 30.1767 28.8061 31.0577 29.6834 31.8915C29.6961 31.9036 29.7076 31.9157 29.7203 31.9284C30.168 32.3761 30.988 32.4093 31.4291 31.9284C31.872 31.4462 31.907 30.697 31.4291 30.2196C30.7281 29.5187 30.0278 28.8184 29.3269 28.1175Z"
          fill="#FF7D7D"
        />
      </g>
      <defs>
        <clipPath id="clip0_17281_589">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
    <div class="updateDataModalFinishText" id="updateDataModalFinishText">
      <h1 *ngIf="status">¡Gracias!</h1>
      <h1 *ngIf="status === false">¡A ocurrido un error!</h1>
      <h2 *ngIf="status">Tus datos han sido actualizados correctamente.</h2>
      <h2 *ngIf="status === false">
        Tus datos no han sido actualizados correctamente.
      </h2>
      <h2 *ngIf="status === false">Vuelve a ingresar e intenta nuevamente.</h2>
    </div>
    <button
      class="updateDataButton"
      id="updateDataButtonFinish"
      (click)="handleEndProcess()"
    >
      Terminar
    </button>
  </div>
</div>
